import { type Route } from '@/types/route'

import { getFirstPossibleRoute } from '../utils/redirectHelpers'

const artisansAndAdminsTabRoutes = [
  {
    path: 'artisans-list',
    name: 'teacher-list' as const,
    component: () =>
      import('@/views/TeachersAdmin/TeachersList/TeachersListView.vue'),
    meta: {
      icon: 'user',
      title: 'Artisans',
      permissions: ['permissions.view_teachers_management']
    }
  },
  {
    path: 'users',
    name: 'users-list' as const,
    component: () => import('@/views/TeachersAdmin/UserList/UserListView.vue'),
    meta: {
      icon: 'calendar',
      title: 'All users',
      permissions: ['permissions.view_users_management']
    }
  }
] satisfies Route[]

const userViewChildrenRoutes = [
  {
    path: 'details',
    name: 'user-details' as const,
    component: () =>
      import('@/views/TeachersAdmin/UserDetails/UserDetailsView.vue'),
    meta: {
      title: 'Details',
      permissions: ['users.view_user']
    }
  },
  {
    path: 'edit',
    name: 'user-edit' as const,
    component: () => import('@/views/TeachersAdmin/EditUser/EditUserView.vue'),
    meta: {
      title: 'User edit',
      permissions: ['users.change_user']
    }
  },
  {
    path: 'custom-schedule',
    name: 'user-custom-schedule' as const,
    component: () => import('@/views/TeachersAdmin/CustomScheduleView.vue'),
    meta: {
      title: 'Artisan custom schedule',
      permissions: ['teachers.change_teacher']
    }
  }
] satisfies Route[]

const artisansAndAdminsNotTabRoutes = [
  {
    path: '',
    name: 'artisans-and-admins-tab' as const,
    component: () => import('@/components/base/BaseLayout.vue'),
    props: {
      routes: artisansAndAdminsTabRoutes
    },
    redirect: () => getFirstPossibleRoute(artisansAndAdminsTabRoutes),
    children: artisansAndAdminsTabRoutes
  },
  {
    path: 'add-user',
    name: 'add-user' as const,
    component: () => import('@/views/TeachersAdmin/AddUser/AddUserView.vue'),
    meta: {
      title: 'User add',
      permissions: ['users.add_user']
    }
  },
  {
    path: 'users/:userId',
    name: 'user-view' as const,
    component: () => import('@/views/Layouts/RouterView.vue'),
    redirect: () => getFirstPossibleRoute(userViewChildrenRoutes),
    children: userViewChildrenRoutes
  }
] satisfies Route[]

export const artisansAndAdminsRoutes = [
  {
    path: 'artisans',
    name: 'artisans-and-admins' as const,
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      title: 'Artisans & Admins',
      icon: 'team',
      permissions: [
        'permissions.view_teachers_management',
        'permissions.view_users_management'
      ]
    },
    redirect: () => getFirstPossibleRoute(artisansAndAdminsNotTabRoutes),
    children: artisansAndAdminsNotTabRoutes
  }
] satisfies Route[]
